const findScriptUrl = (path: string) =>
    Array.from(document.scripts)
        .map(script => script.src)
        .filter(src => src && new URL(src).origin === window.location.origin)
        .find(src => src.includes(path));

export default findScriptUrl;
